/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "VFXJnbnN5ro",
    title: "What is a Nebula?",
    creator: "Atlas Pro",
    category : "Nebula",
    date : "1 year ago",
    views : "251k views",
    cover : "https://i3.ytimg.com/vi/VFXJnbnN5ro/maxresdefault.jpg",
    url : "https://www.youtube.com/watch?v=VFXJnbnN5ro",
  },
  {
    _id: "EFO_bsg1sw8",
    title: "What is a Star?",
    creator: "National Geographic",
    category : "Star",
    date : "3 years ago",
    views : "1.5M views",
    cover : "https://i3.ytimg.com/vi/EFO_bsg1sw8/maxresdefault.jpg",
    url : "https://www.youtube.com/watch?v=EFO_bsg1sw8",
  },
  {
    _id: "8x06kN4ZMOE",
    title: "What is a Planet?",
    creator: "The Verge",
    category : "Planet",
    date : "5 years ago",
    views : "115k views",
    cover : "https://i3.ytimg.com/vi/8x06kN4ZMOE/maxresdefault.jpg",
    url : "https://www.youtube.com/watch?v=8x06kN4ZMOE",
  },
  {
    _id: "L5smi4N8JaY",
    title: "What is a Galaxy?",
    creator: "Space, but messier",
    category : "Galaxy",
    date : "4 years ago",
    views : "3K views",
    cover : "https://i3.ytimg.com/vi/L5smi4N8JaY/maxresdefault.jpg",
    url : "https://www.youtube.com/watch?v=L5smi4N8JaY",
  },
  {
    _id: "uBbxXNhZ78c",
    title: "What is Black Matter?",
    creator: "Science Time",
    category : "Black Matter",
    date : "1 year ago",
    views : "242k views",
    cover : "https://i3.ytimg.com/vi/uBbxXNhZ78c/maxresdefault.jpg",
    url : "https://www.youtube.com/watch?v=uBbxXNhZ78c",
  },

];
